import { render } from "./Filmstrip.vue?vue&type=template&id=4b39ca1c"
import script from "./Filmstrip.vue?vue&type=script&lang=js"
export * from "./Filmstrip.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__